module.exports = __webpack_public_path__ + "static/media/petra_logo.aeec62a9.png";